import { render } from "./LawsuitDocument.vue?vue&type=template&id=760b0f54&scoped=true"
import script from "./LawsuitDocument.vue?vue&type=script&lang=js"
export * from "./LawsuitDocument.vue?vue&type=script&lang=js"

import "./LawsuitDocument.vue?vue&type=style&index=0&id=760b0f54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760b0f54"]])

export default __exports__